import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { Spacer } from 'jbc-front/components/presenters/Spacer';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { Textarea } from 'jbc-front/components/presenters/form/Textarea';
import { Radio, RadioContainer } from 'jbc-front/components/presenters/form/Radio';
import { ErrorMessage } from 'jbc-front/components/presenters/form/ErrorMessage';
import { AnchorTarget } from '@/components/AnchorTarget';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import type { Schema } from '../../schema';

export const Vision: FC = () => {
  const {
    register,
    formState: { errors }
  } = useFormContext<Schema>();
  const visionLeftErrors = errors.items?.visionLeft;
  const visionRightErrors = errors.items?.visionRight;

  return (
    <Panel>
      <Headding>視力</Headding>
      <Item>
        <Panel>
          <AnchorTarget name="vision_left" />
          <Headding>左眼</Headding>
          <Item>
            <div>
              <Label>実施有無</Label>
              <Spacer size={8} />
              <RadioContainer>
                <Radio {...register('items.visionLeft.checked')} value="true">
                  実施
                </Radio>
                <Radio {...register('items.visionLeft.checked')} value="false">
                  未実施
                </Radio>
              </RadioContainer>
              {visionLeftErrors?.checked?.message && <ErrorMessage>{visionLeftErrors.checked.message}</ErrorMessage>}
            </div>
            <div className="u-mt20">
              <Label>結果</Label>
              <Spacer size={8} />
              <Textarea {...register('items.visionLeft.value')} rows={3} isError={!!visionLeftErrors?.value} />
              {visionLeftErrors?.value?.message && <ErrorMessage>{visionLeftErrors.value.message}</ErrorMessage>}
            </div>
          </Item>
        </Panel>
        <Panel>
          <AnchorTarget name="vision_right" />
          <Headding>右眼</Headding>
          <Item>
            <div>
              <Label>実施有無</Label>
              <Spacer size={8} />
              <RadioContainer>
                <Radio {...register('items.visionRight.checked')} value="true">
                  実施
                </Radio>
                <Radio {...register('items.visionRight.checked')} value="false">
                  未実施
                </Radio>
              </RadioContainer>
              {visionRightErrors?.checked?.message && <ErrorMessage>{visionRightErrors.checked.message}</ErrorMessage>}
            </div>
            <div className="u-mt20">
              <Label>結果</Label>
              <Spacer size={8} />
              <Textarea {...register('items.visionRight.value')} rows={3} isError={!!visionRightErrors?.value} />
              {visionRightErrors?.value?.message && <ErrorMessage>{visionRightErrors.value.message}</ErrorMessage>}
            </div>
          </Item>
        </Panel>
      </Item>
    </Panel>
  );
};
